import React from 'react'

const INTERACTIVE_SELECTORS = ['input', 'button', 'a', '.badge', '.form-check']

export const shouldIgnoreClick = (event: React.MouseEvent): boolean => {
  const target = event.target as HTMLElement | null
  const container = event.currentTarget as HTMLElement | null

  if (!target) {
    return true
  }

  if (container && !container.contains(target)) {
    return true
  }

  return INTERACTIVE_SELECTORS.some((selector) => target.closest(selector) !== null)
}
